import type { TranslateAbleText } from './translate-able-text';
import { resolveTranslateAbleText } from './resolve-translate-able-text';
import { isString } from '@pct-ts/typeguard';
import type { TranslateParams, Translation } from '@jsverse/transloco';

export interface I18nService {
  translate<T = string>(key: TranslateParams, params?: Translation, lang?: string): T;
}

export function translateTranslateAbleText(
  value: TranslateAbleText | null | undefined,
  i18nService?: I18nService,
): string {
  const result = resolveTranslateAbleText(value);
  if (isString(result)) {
    return result;
  }

  const params = result.params ?? undefined;

  return i18nService?.translate(result.key, params) ?? result.key;
}
